import styled from 'styled-components';

export const CellListContainer = styled.div({
  display: 'flex',
  height: '28px',
  alignItems: 'center',
  containerType: 'inline-size',
  containerName: 'cell',

  '&::before': {
    content: '""',
    display: 'none',
    color: '#888',
    fontWeight: 'bold',
    fontSize: 12,
    marginRight: 4,
  },

  '@container cell (min-width: 150px)': {
    '&::before': {
      content: (props) => (props.$isStacked ? `"${props.$label} "` : '""'),
      display: 'inline',
    },
  },
});

export const CellListContent = styled.div({
  backgroundColor: (props) =>
    props.$isStacked ? 'var(--ds-bg-base)' : 'var(--ds-bg-secondary)',
  borderRadius: '3px',
  display: 'inline-flex',
  padding: '4px',
  paddingLeft: '6px',
  verticalAlign: 'center',
  width: 'calc(100% - 4px)',
  maxWidth: '200px',
  marginLeft: '4px',
  height: '24px',
});
export const CellListIcon = styled.div(({ $color, $icon }) => ({
  backgroundColor: $color || 'var(--ds-icon-base)',
  display: 'flex',
  height: '16px',
  WebkitMaskImage: `url('${$icon ?? '/img/alert.svg'}')`,
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskSize: '16px 16px',
  position: 'relative',
  paddingLeft: '12px',
  width: '18px',
}));

export const CellListText = styled.div({
  color: 'var(--ds-text-base)',
  display: 'flex',
  fontFamily: 'proxima-nova',
  fontSize: 12,
  fontWeight: '500',
  lineHeight: '15px',
  overflow: 'hidden',
  paddingLeft: '6px',
  textOverflow: 'ellipsis',
  verticalAlign: 'center',
});
